import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

interface CustomButtonProps {
  type: "button" | "submit" | "reset";
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  isDisabled?:boolean;
}

const GvPrimaryButton: React.FC<CustomButtonProps> = ({
  type,
  children,
  onClick,
  className,
  isDisabled=false,
}) => {
  return (
    <Box className="w-full" >
      <Button
        id="createProfileFormButton"
        color="primary"
        type={type}
        disabled={isDisabled}
        className={`bottom-button ${className} !capitalize`}
        fullWidth
        onClick={onClick}

      >
        {children}
      </Button>
    </Box>
  );
};

export default GvPrimaryButton;
